<template>
    <div>
        <submittal-table ref="table" :createBtn="false" :userId="this.$store.state.user.user.id"/>
    </div>
</template>

<script>
import SubmittalTable from '@/components/pages/project/administrative/ticket/submittal/submittal_table.vue';
import Vue from 'vue';

export default {
    name: 'sent_submittal',
    components: {
        SubmittalTable
    },
    methods: {
        loadTable () {
            this.$refs.table.onLoadTable();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/administrative/ticket/submittal/sent_submittal.vue